import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";

export const allSecurityGroups = async () => {
  let orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
  let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
  let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);

  const securityGroups = [
    {
      Name: "launch-wizard-14",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-14 created 2018-11-23T08:36:12.468+05:30",
      Tags: [
        {
          Key: "Name",
          Value: "els",
        },
      ],
      ResourceId: "sg-0008bef9e622b9c17",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-14",
    },
    {
      Name: "launch-wizard-18",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-18 created 2019-02-08T14:43:25.903+05:30",
      Tags: [],
      ResourceId: "sg-0011fe14ed4bd9ba0",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-18",
    },
    {
      Name: "launch-wizard-16",
      OwnerId: "568753834354",
      VpcId: "vpc-4f5b6327",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-16 created 2019-08-13T09:58:40.193+05:30",
      Tags: [
        {
          Key: "Name",
          Value: "els",
        },
      ],
      ResourceId: "sg-001df298f00e3a456",
      RegionCode: "us-east-2",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-16",
    },
    {
      Name: "launch-wizard-57",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-57 created 2019-08-28T13:17:27.639+05:30",
      Tags: [],
      ResourceId: "sg-008ab47670a0d7e04",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-57",
    },
    {
      Name: "launch-wizard-54",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-54 created 2019-07-29T13:53:15.075+05:30",
      Tags: [],
      ResourceId: "sg-009f710b56612fc88",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-54",
    },
    {
      Name: "launch-wizard-62",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-62 created 2019-12-03T16:40:52.209+05:30",
      Tags: [],
      ResourceId: "sg-00d7d85c9d868a076",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-62",
    },
    {
      Name: "launch-wizard-12",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-12 created 2018-11-14T17:51:06.451+05:30",
      Tags: [],
      ResourceId: "sg-00eaf7cf8ddd91bd6",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-12",
    },
    {
      Name: "launch-wizard-8",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-8 created 2018-11-07T14:45:10.601+05:30",
      Tags: [],
      ResourceId: "sg-0147d7834020caf1e",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-8",
    },
    {
      Name: "launch-wizard-25",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-25 created 2019-02-25T19:40:13.564+05:30",
      Tags: [],
      ResourceId: "sg-01508285b2b8dfd49",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-25",
    },
    {
      Name: "launch-wizard-30",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-30 created 2019-03-20T18:02:55.680+05:30",
      Tags: [],
      ResourceId: "sg-01efb5c8ebec21c71",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-30",
    },
    {
      Name: "launch-wizard-1",
      OwnerId: "568753834354",
      VpcId: "vpc-1594696f",
      AccountNumber: "568753834354",
      UpdatedAt: null,
      Description: "launch-wizard-1 created 2018-10-15T09:23:47.034+05:30",
      Tags: [],
      ResourceId: "sg-020cef19683477f9f",
      RegionCode: "us-east-1",
      OrganizationId: selectedOrg.orgId,
      DepartmentId: selectedDept.deptId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: "launch-wizard-1",
    },
  ];

  return securityGroups.map(sg => {
    sg.ARN = `arn:aws::securitygroup:${sg.RegionCode}:${faker.random.alphaNumeric(15)}`
    return sg
  })

};
